<template>
  <div class="body">
    <div class="dh">
      <div
        style="
          width: 356px;
          min-height: 990px;
          border-right: 20px solid#F2F2F2;
          display: flex;
          flex-direction: column;
          background-color: #ffffff;
        "
      >
        <div
          style="
            width: 336px;
            height: 70px;
            background-color: #015293;
            padding: 20px;
            display: flex;
            flex-direction: row;
          "
        >
          <div class="div1" style="background-color: #ffffff"></div>
          <h1
            style="
              width: 200px;
              height: 18px;
              font-size: 18px;
              font-weight: bold;
              color: #ffffff;
            "
          >
            团 体 会 员 单 位
          </h1>
        </div>

        <div class="style5" v-for="(item, i) in items" :key="i">
          <br />
          <div id="tb"></div>

          <span @click="tochild(item)" class="cursor">{{ item.title }}</span>

          <br />
        </div>
      </div>
      <div style="background-color: white; width: 848px; padding: 66px 106px">
        <div v-html="html"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tthydw",
  data() {
    return {
      items: "",
      html: "",
      id: this.$route.query.id,
    };
  },
  created() {
    this.$axios
      .get("/get_detail", {
        params: {
          id: this.id,
        },
      })
      .then((Response) => {
        this.items = Response.data.data.list;
        this.html = Response.data.data.detail.content;
      });
  },
  methods: {
    tochild(data) {
      this.html = data.content;
    },
  },
};
</script>
<style>
.body {
  background-color: #f2f2f2;
}

.dh {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
}
.style5 {
  width: 336px;
  display: flex;
  flex-direction: row;
  padding: 15px 20px;
}
.cursor {
  cursor: pointer;
}

#tb {
  height: 8px;
  width: 8px;
  background: linear-gradient(to left, #015293, #015293) no-repeat left top,
    linear-gradient(to left, #015293, #015293) no-repeat right top,
    linear-gradient(to left, #015293, #015293) no-repeat left bottom,
    linear-gradient(to left, #015293, #015293) no-repeat right bottom, #ffffff;
  background-size: 2px 3px, 4px 3px, 2px 3px, 4px 3px;
  margin-top: 7px;
  margin-right: 5px;
}
.style5:hover {
  background-color: #e1edfa;
}
.div1 {
  width: 3px;
  height: 15px;
  line-height: 50px;
  background: #ffffff;
  text-align: center;
  margin-top: 5px;
  margin-right: 5px;
}
</style>